// export const cmsApi = 'http://192.168.0.15:84/api'; // New Api one server //test old
// http://54.255.222.19/one_webservice/api

// Adev
// export const cmsApi: string = 'http://13.250.182.248/one_webservice/api/' //test adev
// export const oneAssetApi: string = 'http://tmapi.one-asset.com/api' // tEST *one server

// Test
// export const cmsApi = 'http://192.168.0.13:884/api'; // New Api one server //test new
// //export const cmsApi = 'http://localhost:8420/api'; // New Api one server //test new
// //export const oneAssetApi = 'http://localhost:5327/api'
// //export const oneAssetApi = 'http://tmapi.one-asset.com/api'; // tEST *one server
// export const oneAssetApi = 'http://192.168.0.82:440/api'; //

// export const cmsApi = 'http://192.168.0.15:884/api'; // New Api one server //test new
// export const oneAssetApi = 'http://192.168.0.15:80/api'; //

// // Production
export const cmsApi: string = 'https://webapi.one-asset.com/one_webservice/api'  // one server //production
export const oneAssetApi: string = 'https://api.one-asset.com/api' //production

// Production
// export const cmsApi: string = 'https://webapiaws.one-asset.com/one_webservice/api'  // one server //AWS
// export const oneAssetApi: string = 'https://mobileaws.one-asset.com/api' //AWS



// language part
import { th } from './language/th';
import { en } from './language/en';

export const EN = en;
export const TH = th;

export const mobileMaxScreen = 500;

